module.exports = __webpack_public_path__ + "assets/img/sxjkm.272e041b.png";